import { useEffect, useState } from "react";
// REDUX
import { useGetOrganizationsLightQuery } from "../../redux/organizations/organizationAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { OganizationLightInterface } from "../../interfaces/Organizations.interface";

// withBanks=true asks the backend (/orgs/light?with_banks=true) to return only
// orgs the caller can VIEW a bank in — the switcher uses this so its org list
// matches the per-bank-scoped monitoring cascader. Default false keeps the full
// org-tree list for admin pickers.
/**
 * Fetches the minimal organisation projection via `useGetOrganizationsLightQuery`,
 * optionally including each organisation's banks.
 *
 * Resolves a JWT first and passes it to the query, which stays skipped until the
 * token arrives. Scoped to the globally selected organisation unless overridden.
 */
export default function useGetAllOrganizationsLight(withBanks = false) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [organizations, setOrganizations] = useState<OganizationLightInterface[]>([]);
  const [token, setToken] = useState<string | null>(null);
  const [errorObject, setErrorObject] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<string>("Error");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { data, isLoading, isError, isFetching, error } = useGetOrganizationsLightQuery(
    { token, withBanks },
    { skip: !token, refetchOnMountOrArgChange: false },
  );

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    GETJwtToken().then(setToken);
  }, []);

  useEffect(() => {
    if (data && data.data) {
      setOrganizations(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setErrorObject(error);
    }
  }, [error]);

  useEffect(() => {
    if (errorObject && errorObject.data && errorObject.data.message) {
      setErrorMessage(errorObject.data.message);
    }
  }, [errorObject]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return {
    organizationsLight: organizations,
    isLoadingGetAllOrganizationsLight: isLoading || isFetching,
    errorMessageGetAllOrganizationsLight: errorMessage,
    isErrorGetAllOrganizationsLight: isError,
    totalRowsGetAllOrganizationsLight: data?.total ?? 0,
  };
}
